export enum SurveyType {
    YesNo = "YesNo",
    TrueFalse = "TrueFalse",
    ForAgainstNoOpinion = "ForAgainstNoOpinion",
    MultipleChoice = "MultipleChoice",
    Percentage = "Percentage",
    Number = "Number",
    WordCloud = "WordCloud",
    Stars = "Stars",
};

export enum SurveyAnswerType {
    Yes = 'Oui',
    No = 'Non',
    True = 'Vrai',
    False = 'Faux',
    For = 'Pour',
    Against = 'Contre',
    NoOpinion = 'Pas d\'opinion',
    Percentage = 'Pourcentage',
    Number = 'Nombre',
}

export enum ForAgainstNoOpinion {
    For = 'Pour',
    Against = 'Contre',
    NoOpinion = 'Ne se prononce pas',
}

export enum SurveyCreationStep {
    SelectSurveyType,
    SelectSurveySubType,
    WaitSurveyAwnser,
    WaitSurveyResult,
    SurveyResult,
}